import React from 'react';
import PropTypes from 'prop-types';

export const ArticleShortcut = ({ width, height, ...props }) => (
  <svg
    data-icon='article-shortcut'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M10 17h4v-2h-4v2Zm0-4h7v-2h-7v2ZM7 9h10V7H7v2Zm-.375 13c-1.317 0-2.438-.462-3.362-1.387-.925-.925-1.388-2.046-1.388-3.363 0-.95.246-1.8.737-2.55A4.713 4.713 0 0 1 4.55 13H2v-2h6v6H6v-2.425a2.607 2.607 0 0 0-1.525.95c-.4.5-.6 1.075-.6 1.725 0 .767.27 1.417.813 1.95.541.533 1.187.8 1.937.8v2ZM10 21v-2h9V5H5v4H3V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h14c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21h-9Z'
    />
  </svg>
);

ArticleShortcut.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ArticleShortcut.defaultProps = {
  width: 24,
  height: 24,
};
